<template>
  <div v-show="modal == true" v-if="items" class="modal-content">
    <div v-click-outside="onClickOutside" class="modal-quiz">
      <div class="item--title">
        <span class="item--title">
          {{ items.question }}
        </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            class="item--close-icon"
            id="user--btn-icon"
            icon="times"
        /></span>
      </div>
      <div class="form-quiz">
        <div @click="sendQuiz(items.option1.id)" class="option-box">
          <figure class="option--img">
            <img :src="items.option1.imageUrl" :alt="items.option1.title" />
          </figure>
          <p class="option--text">
            {{ items.option1.percentage | percenet_filter }} %
          </p>
        </div>
        <div class="option--divisor"><span>or</span></div>
        <div @click="sendQuiz(items.option2.id)" class="option-box">
          <figure class="option--img">
            <img :src="items.option2.imageUrl" :alt="items.option2.title" />
          </figure>
          <p class="option--text">
            {{ items.option2.percentage | percenet_filter }} %
          </p>
        </div>
      </div>
      <div class="option-end" @click="sendQuiz(null)">
        <span>Don’t ask me again</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "IthQuiz",
  data: () => ({
    items: null,
    directives: {
      clickOutside: vClickOutside.directive
    },
    alert: { color: "", message: "" },
    modal: true
  }),
  mounted() {
    if (this.user != null && this.user.username) {
      this.$Parse.Cloud.run("getQuiz")
        .then(res => {
          this.items = res;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: mapState(["user"]),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "modal-content") {
        this.modal = false;
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.modal = false;
    },
    sendQuiz(id) {
      let params = { quizId: this.items.id, answerId: id };
      this.$Parse.Cloud.run("saveQuizAnswer", params)
        .then(() => {
          this.modal = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: fixed;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-quiz {
  background-color: rgba(0, 0, 0, 0.5);
  height: 450px;
  width: 500px;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 80px 300px 30px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}
.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 30px;
}
.form-quiz {
  display: grid;
  grid-template-columns: 180px 30px 180px;
  justify-content: space-between;
}

.option--img {
  width: 180px;
  height: 240px;
  cursor: pointer;
  margin: 0;
}
.option--img > img {
  width: 180px;
  height: 240px;
  object-fit: contain;
  border-radius: 15px;
}
.option-box {
  width: 180px;
}
.option--text {
  width: 180px;
  text-align: center;
  margin: 5px 0;
}

.option--divisor {
  font-size: 1.5em;
  align-self: center;
  color: #738092;
}
.option-end {
  width: 100%;
  text-align: center;
  color: #738092;
  cursor: pointer;
  font-size: 0.8em;
  text-decoration: underline;
}
@media (min-width: 1480px) {
  .modal-quiz {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-quiz {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-quiz {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-quiz {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-quiz {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-quiz {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-quiz {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
